import { useState, useEffect } from "react";
import fetch from "../../utils/fetch";
import BlogCard from "../Blog/BlogCard";
import { BlogSlider } from "../Blog/BlogSlider";
import BlogCardSkeleton from "../Blog/BlogCardSkeleton";

type BlogListProps = {
  activeList: string;
  isLoadingList: boolean;
  setIsLoadingList: (boolean) => void;
  setPopularList?: any;
};

const BlogList = ({
  activeList,
  isLoadingList,
  setIsLoadingList,
  setPopularList
}: BlogListProps) => {
  const [blogList, setBlogList] = useState(null);
  const getBlogList = async () => {
    const { status, data } = await fetch(
      "GET",
      `/kentico/blog`,
      {
        limit: 5,
        slug: activeList
      },
      true
    );
    if (status == 200) {
      activeList === "terpopuler" && setPopularList(data);
      setBlogList(data);
      setIsLoadingList(false);
    }
  };
  useEffect(() => {
    if (isLoadingList) {
      return;
    }
    setIsLoadingList(true);
    getBlogList();
  }, []);
  return (
    <>
      {isLoadingList && isLoadingList ? (
        <BlogSlider>
          <BlogCardSkeleton></BlogCardSkeleton>
        </BlogSlider>
      ) : (
        activeList !== "terpopuler" && (
          <div
            className="blog-card-wrapper"
            style={{ maxWidth: activeList === "" ? "626.73px" : "940px" }}
          >
            <BlogSlider>
              {blogList &&
                blogList.item.map((data, key) => {
                  return (
                    <div key={key}>
                      <BlogCard
                        key={data.slug}
                        thumbnail={data.thumbnail}
                        title={data.title}
                        excerpt={data.excerpt}
                        slug={data.slug}
                        tags={data.tags}
                      />
                    </div>
                  );
                })}
            </BlogSlider>
          </div>
        )
      )}
      <style jsx>{`
        .blog-card-wrapper {
          display: flex;
          width: 100%;
          min-height: 398.6px;
        }
      `}</style>
    </>
  );
};

export default BlogList;
